import { gql } from '@apollo/client';

export const ALL_REGIONS = gql`
  query AllRegions($input: NameSearchArgs!) {
    regions: getRegions(input: $input) {
      id
      name
    }
  }
`;
